import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

import { PageIdWoofzInvx } from './pages'

type TIdToPageMapWoofzInvx = Record<PageIdWoofzInvx, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_INVX: TIdToPageMapWoofzInvx = {
  [PageIdWoofzInvx.SUBSCRIPTIONS_INVOXIA_INVX]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_invx/pages/subscriptions/SubscriptionsInvx'
      ).then((m) => ({
        default: m.SubscriptionsInvx,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_invx/pages/subscriptions/SubscriptionsInvx'),
  },
  [PageIdWoofzInvx.INVOXIA_CONGRATULATIONS_INVX]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_invx/pages/congratulations/InvoxiaCongratulationsInvx'
      ).then((m) => ({
        default: m.InvoxiaCongratulationsInvx,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_invx/pages/congratulations/InvoxiaCongratulationsInvx'
      ),
  },
  [PageIdWoofzInvx.INVOXIA_REVIEW_INVX]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_invx/pages/review/InvoxiaReviewInvx').then(
        (m) => ({
          default: m.InvoxiaReviewInvx,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_invx/pages/review/InvoxiaReviewInvx'),
  },
  [PageIdWoofzInvx.INVOXIA_DETAILS_INVX]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_invx/pages/details/InvoxiaDetailsInvx').then(
        (m) => ({
          default: m.InvoxiaDetailsInvx,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_invx/pages/details/InvoxiaDetailsInvx'),
  },
}
